
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    Button,
  } from "@material-tailwind/react";
import { CiBullhorn } from "react-icons/ci";
import Alx1 from "../../assets/images/Alx_img1.png"
   
  export function AboutCard1({ pageDet }) {

      const { title, subtitle1, subtitle2, cat1, cat1_desc, cat2, cat2_desc, cat3, cat3_desc, about_img_url, about_name, about_title, about_text, more_sandy, created_at, del } = pageDet
      
    return (
      <Card className="w-full sm:flex-row">
        <CardHeader
          shadow={false}
          floated={false}
          className="m-0 w-full sm:w-2/5 shrink-0 sm:rounded-r-none sm:rounded-l-xl rounded-t-xl rounded-b-none"
        >
          <img
            src={Alx1}
            alt="card-image"
            className="sm:h-full w-full object-cover"
          />
        </CardHeader>
        <CardBody className="px-0 sm:p-6">
            <div className="general-container">
                <div className="services-right px-4 py-2">
                    <div className="about-header mb-2">
                        <h2>About Language Helpers</h2>
                        <p>
                            {about_text}
                        </p>
                        <h4>We serve a variety of industries:</h4>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Education</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Healthcare</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Government</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Travel and Hospitality</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Legal</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Social Services</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Business</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Marketing and Advertising</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Non-Profit Agencies</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Human Resources</p>
                        <p className="flex"><span className="ml-2 mr-3 mt-1.5"><CiBullhorn size={17} /></span> Political conferences</p>
                    </div>
                </div>
            </div>
        </CardBody>
      </Card>
    );
  }